import { FileText, UserCheck, ShieldCheck, PaintRoller, MessagesSquare } from "lucide-react";
import { Reveal } from "./Reveal";

const ITEMS = [
  { icon: FileText, title: "Devis clair", text: "Un chiffrage compréhensible et détaillé." },
  { icon: UserCheck, title: "Suivi rigoureux", text: "Un interlocuteur identifié à chaque étape." },
  { icon: ShieldCheck, title: "Chantier protégé", text: "Préparation et protection des espaces." },
  { icon: PaintRoller, title: "Finitions soignées", text: "Une attention portée jusqu’aux détails." },
  { icon: MessagesSquare, title: "Communication", text: "Des informations claires pendant le chantier." },
];

export const TrustBar = () => (
  <section id="engagements" data-testid="trust-bar" className="border-y border-mineral bg-white">
    <div className="mx-auto max-w-7xl px-6 lg:px-10 py-14 lg:py-16 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-x-8 gap-y-10">
      {ITEMS.map((item, i) => (
        <Reveal key={item.title} delay={i * 0.08}>
          <div data-testid={`trust-item-${i + 1}`} className="group">
            <item.icon size={26} strokeWidth={1.25} className="text-nuit group-hover:text-sable-deep transition-colors duration-300" aria-hidden="true" />
            <h3 className="mt-4 font-accent text-[13px] font-medium tracking-[0.16em] uppercase text-nuit">{item.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-anthracite/65">{item.text}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
